/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {LocationInstance} from "../models/location-instance";
import {LocationService} from "../services/location.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class LocationInstancesResolver implements Resolve<LocationInstance[]> {

  constructor(
    private mLocationService: LocationService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<LocationInstance[]> {
    try {
      return await this.mLocationService.getAllLocationInstances();
    } catch (error) {
      console.error("Problem resolving Location Instances... Error: " + error, error);
    }
  }

}
